<style scoped>
.table-icons {
  float: right;
}
</style>

<template>
  <div>
    <div class="title">Bestellijsten</div>
    <div class="subtitle">Eerstvolgende leverdag</div>
    <bezorglijstTable :index="upComingOrderDay" />
    <br />
    <hr />
    <br />
    <div>
      <b-tabs
        expanded
        position="is-centered"
        class="block"
        v-model="activeTab"
        @input="syncActiveTabToQuery()"
      >
        <b-tab-item label="Leverdagen" value="leverdagen">
          <bezorglijstTable :index="upComingDays" />
        </b-tab-item>
        <b-tab-item label="Archief" value="archief">
          <bezorglijstTable :index="archief" />
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import bezorglijstTable from "./BezorglijstTable.vue";

export default {
  components: {
    bezorglijstTable,
  },
  props: [],
  data() {
    return {
      activeTab: "leverdagen",
      selected: null,
    };
  },
  computed: {
    index() {
      const data = this.$store.getters["bestellijsten/index"];

      if (data.data) {
        return data.data;
      }

      return [];
    },
    archief() {
      const today = new Date();
      today.setMinutes(0);
      today.setHours(0);
      today.setSeconds(0);
      const aankomende_dagen = this.index.filter(
        (a) => new Date(a.bestellingsdag) < today
      );
      if (aankomende_dagen.length) {
        return aankomende_dagen.reverse();
      }
      return [];
    },
    upComingDays() {
      const today = new Date();
      today.setMinutes(0);
      today.setHours(0);
      today.setSeconds(0);
      const aankomende_dagen = this.index.filter(
        (a) => new Date(a.bestellingsdag) > today
      );

      if (aankomende_dagen.length) {
        return aankomende_dagen.reverse();
      }
      return [];
    },
    upComingOrderDay() {
      if (this.upComingDays.length) {
        const day = this.upComingDays;

        const orderdayarray = [];
        orderdayarray.push(day[0]);
        return orderdayarray;
      }

      return [];
    },
  },
  methods: {
    updateSelected(value) {
      this.selected = value;
    },
    syncActiveTabToQuery() {
      if (this.$router.currentRoute.query.activeTab !== this.activeTab) {
        this.$router.replace({ query: { activeTab: this.activeTab } });
      }
    },
    getActiveTabFromQuery() {
      if (this.$router.currentRoute.query.activeTab) {
        this.activeTab = this.$router.currentRoute.query.activeTab;
      }
    },
  },
  mounted() {
    this.getActiveTabFromQuery();
  },
};
</script>
